import { PurchaseResponse } from "@/payments/types";

export const createRejectError = (e: unknown): PurchaseResponse => ({
  status: false,
  subjectPurchased: false,
  error: e as Error,
});
